import React from 'react';
import '../css/Account.css';

export default class AccountPage extends React.Component {
    renderUserProfile() {
        return (
            <div className="app-page" id="account-page">
                <div id="welcome-msg">Welcome!</div>
                {/* <span id="user-name">{this.props.name}</span>!</div> */}
                <div id="user-info-container">
                    Show this QR to the barista when checking out your drink in a cuppy!
                </div>
                <div id="user-qr-code-container">
                    <img alt="user-qr-code" id="user-qr-code" src={this.props.userQRCode}></img>
                </div>
                <div id="user-id-container">USER ID: {this.props.userID}</div>

                <button id="manual-checkout-btn" onClick={()=>{this.props.manualCheckout()}}>Manual Checkout ></button>

                <div id="cups-status">
                    Currently, you have <span id="number-of-cups">{this.props.userCupsOut}</span> cups checked out.
                </div>

                <div id="cups-saved">
                    You have saved <span id="number-cups-saved">{this.props.userCupsSaved}</span> cup(s) so far!
                </div>
                {/* <div id="user-history-container">
                    <p id="history-header">Previous Visits</p>
                    <table id="user-history-table">
                        <tbody>
                            <tr>
                                <th>Date</th>
                                <th>Location</th>
                                <th>Usage</th>
                            </tr>
                            <tr>
                                <td>May 30, 2019</td>
                                <td>Beaucoup Bakery</td>
                                <td>Return: 1<br/>Checkout: 1</td>
                            </tr>
                            <tr>
                                <td>May 29, 2019</td>
                                <td>Green Coast Coffee</td>
                                <td>Checkout: 1</td>
                            </tr>
                        </tbody>
                    </table>
                </div> */}
                <button onClick= {() => { this.props.goToMap(); }} id="find-locations-btn">Find Participating Locations ></button><br/>
                <button onClick={() => { this.props.logOut(); }} id="logout-btn">LOG OUT</button>
            </div>
        )
    }

    renderVendorProfile() {
        return (
            <div className="app-page" id="vendor-account-page">
                <div id="welcome-msg">Welcome <span id="vendor-name">{this.props.vendorName}</span>!</div>
                
                <button onClick={() => { this.props.checkoutScan(); }} className="scan-btn" id="checkout-scan-btn">SCAN CHECKOUT</button>
                <button onClick={() => { this.props.checkinScan(); }} className="scan-btn" id="checkin-scan-btn">SCAN RETURN</button>
                <button onClick={() => { this.props.refillScan(); }} className="scan-btn" id="refill-scan-btn">SCAN REFILL</button>
                
                <div className="vendor-info-container" id="store-inventory">
                    Your current useable inventory is: <span className="info-no" id="remaining-cups">{this.props.vendorInven}</span>
                </div>

                <div className="vendor-info-container" id="store-checkouts">
                    Cups that have been checked out at your store: <span className="info-no" id="checkout-cups">{this.props.vendorCheckouts}</span>
                </div>
               
               <div className="vendor-info-container" id="store-returns">
                   Cups that have been returned to your store: <span className="info-no" id="return-cups">{this.props.vendorReturns}</span>
                </div>
                
                {/* <div className="vendor-info-container" id="user-signup">
                    Users that have signed up at this location: <span className="info-no" id="number-of-users">{this.props.vendorSignups}</span>
                </div> */}
                
                <button onClick = {() => { this.props.logOut(); }} id="vendor-logout-btn">LOG OUT</button>
            </div>
        );
    }
    
    render() {
        if (this.props.userType === 'user') {
            return this.renderUserProfile();
        } else if (this.props.userType === 'vendor') {
            return this.renderVendorProfile();
        }
    }
}

